import type { AppStore } from 'store';

let store: AppStore | null = null;

const StoreService = {
  setStore: (s: AppStore) => {
    store = s;
  },
  getStore: (): AppStore => {
    if (!store) {
      throw new Error('Store has not been initialized');
    }
    return store;
  },
};

export default StoreService;
